


<form (submit)="onSubmit()" [formGroup]="form" *ngIf="!showForgottenPassword">

  <div class="p-fluid grid">

    <div *ngIf="emailFC" class="col-12 p-fluid">
      <span class="p-input-icon-right">
        <i *ngIf="checkingEmail" class="pi pi-spin pi-spinner"></i>
        <input type="text" id="email" placeholder="{{ 'admin.auth.email-input.placeholder' | translate }}" formControlName="email" pInputText/>
      </span>
    </div>

    <div *ngIf="passwordFC" class="col-12 p-fluid">
      <input
        type="password"
        id="password"
        placeholder="{{ 'admin.auth.password-input.placeholder' | translate }}"
        formControlName="password"
        pInputText
        [autocomplete]="AuthComponentState.SIGN_IN === state ? 'current-password' : 'new-password'"
        />
    </div>  

    <ng-container *ngIf="state === AuthComponentState.SIGN_IN && passwordFC">
      <div
        class="col-12 py-2">
        <span
          class="text-color-secondary">
          <u (click)="onForgottenPassword()" class="cursor-pointer">{{ 'admin.auth.forgotten-passwd-label' | translate }}</u>
        </span>
      </div>
    </ng-container>

    <ng-container *ngIf="state === AuthComponentState.SIGN_UP">
      <div class="col-12">
        <p-message severity="info" [text]="'admin.auth.sign-up.info-label' | translate"></p-message>
        <p class="mt-2 mb-1">{{ 'admin.auth.sign-up.info-sublabel' | translate }}</p>
      </div>

      <div *ngIf="nameFC" class="field col-12 p-fluid">
        <span class="p-float-label p-input-icon-right">
          <input type="text" id="name" formControlName="name" pInputText/>
          <label for="name">{{ 'admin.auth.name-input.label' | translate }}</label>
        </span>
      </div>

      <div *ngIf="surnameFC" class="field col-12 p-fluid">
        <span class="p-float-label p-input-icon-right">
          <input type="text" id="surname" formControlName="surname" pInputText/>
          <label for="surname">{{ 'admin.auth.surname-input.label' | translate }}</label>
        </span>
      </div>

    </ng-container>

  </div>


  <button
    *ngIf="state !== AuthComponentState.INIT"
    (click)="onSubmit()"
    pButton [loading]="loading"
    [disabled]="loading"
    type="submit"
    label="{{ state === AuthComponentState.SIGN_UP ? ('admin.auth.sign-up-btn.label' | translate) : ('admin.auth.sign-in-btn.label' | translate) }}"
    class="mt-3">
  </button>


</form>


<ng-container *ngIf="showForgottenPassword" [formGroup]="forgottenPasswordFG">

  <div class="p-fluid grid">

    <div class="field col-12 p-fluid">
      <span class="p-float-label p-input-icon-right">
        <i *ngIf="checkingEmail" class="pi pi-spin pi-spinner"></i>
        <input type="text" id="email" formControlName="email" pInputText/>
        <label for="email">{{ 'admin.auth.email-input.label' | translate }}</label>
      </span>
    </div>

  </div>

  <button
    (click)="onSubmitPasswordReset()"
    pButton [loading]="sendingResetPasswordEmail"
    [disabled]="sendingResetPasswordEmail"
    [label]="'admin.auth.renew-passwd-btn.label' | translate">
  </button>

</ng-container>
